export default "__VITE_ASSET__CYo9ikyM__"